// HTML symbols to unescape in a Alphanumeric value : Literal mapping.
const alphanumericMap = {
  cent: '¢',
  pound: '£',
  sect: '§',
  copy: '©',
  laquo: '«',
  raquo: '»',
  reg: '®',
  deg: '°',
  plusmn: '±',
  para: '¶',
  middot: '·',
  frac12: '½',
  mdash: '—',
  ndash: '–',
  lsquo: '‘',
  rsquo: '’',
  sbquo: '‚',
  rdquo: '”',
  ldquo: '“',
  dagger: '†',
  Dagger: '‡',
  bull: '•',
  hellip: '…',
  prime: '′',
  Prime: '″',
  euro: '€',
  trade: '™',
  asymp: '≈',
  ne: '≠',
  le: '≤',
  ge: '≥',
  quot: '"',
};
export default alphanumericMap;
